module.exports = __webpack_public_path__ + "static/media/entrance2.f0534660.jpg";